/**
 * @generated SignedSource<<16a42a2a73b990ac1f721e5a2f583933>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DietaryTags = "ALCOHOL_FREE" | "ALLERGY" | "ALLIUM" | "CRUSTACEAN" | "DAIRY_FREE" | "DIABETIC" | "EGGS" | "FISH" | "GARLIC" | "GLUTEN_FREE" | "HAZELNUT" | "KOSHER" | "MILK" | "MUSHROOMS" | "NIGHTSHADE" | "NUTS" | "PALEO" | "PEANUTS" | "PESCATARIAN" | "PORK" | "POULTRY" | "PREGNANT" | "RED_MEAT" | "SALT" | "SEAFOOD" | "SHELLFISH" | "SHRIMP" | "SOY" | "SULFITES" | "TOMATOES" | "TREE_NUTS" | "VEGAN" | "VEGETARIAN" | "WALNUTS" | "WHEAT";
export type OccasionTags = "ANNIVERSARY" | "BIRTHDAY" | "BUSINESS_MEETING" | "CELEBRATION" | "CORPORATE_EVENT" | "GRADUATION" | "SPECIAL_EVENT";
export type DiningBookingWizardQueryRendererQuery$variables = {
  reservationHoldId: string;
};
export type DiningBookingWizardQueryRendererQuery$data = {
  readonly diningReservationHold: {
    readonly date: string | null | undefined;
    readonly expiresAt: string | null | undefined;
    readonly facility: {
      readonly club: {
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
      } | null | undefined;
      readonly diningDietaryTags: ReadonlyArray<DietaryTags> | null | undefined;
      readonly diningOccasionTags: ReadonlyArray<OccasionTags> | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly partySize: number | null | undefined;
    readonly policy: string | null | undefined;
    readonly roomName: string | null | undefined;
    readonly startSlot: {
      readonly id: string;
    } | null | undefined;
    readonly time: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeDiningBookingWizard_diningReservationHold">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeDiningBookingWizard_session">;
  } | null | undefined;
};
export type DiningBookingWizardQueryRendererQuery = {
  response: DiningBookingWizardQueryRendererQuery$data;
  variables: DiningBookingWizardQueryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationHoldId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reservationHoldId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partySize",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "policy",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roomName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diningDietaryTags",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diningOccasionTags",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v8/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "BucketTimeSlot",
  "kind": "LinkedField",
  "name": "startSlot",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiningBookingWizardQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DiningReservationHold",
        "kind": "LinkedField",
        "name": "diningReservationHold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facility",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClubLogo_Club"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeDiningBookingWizard_diningReservationHold"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeDiningBookingWizard_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiningBookingWizardQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DiningReservationHold",
        "kind": "LinkedField",
        "name": "diningReservationHold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facility",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "profileImage",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01b6019951456edde3b0d561a8408621",
    "id": null,
    "metadata": {},
    "name": "DiningBookingWizardQueryRendererQuery",
    "operationKind": "query",
    "text": "query DiningBookingWizardQueryRendererQuery(\n  $reservationHoldId: ID!\n) {\n  diningReservationHold(id: $reservationHoldId) {\n    date\n    expiresAt\n    partySize\n    policy\n    roomName\n    time\n    facility {\n      id\n      diningDietaryTags\n      diningOccasionTags\n      club {\n        name\n        ...ClubLogo_Club\n        id\n      }\n    }\n    startSlot {\n      id\n    }\n    ...useInitializeDiningBookingWizard_diningReservationHold\n    id\n  }\n  session {\n    ...useInitializeDiningBookingWizard_session\n  }\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment useInitializeDiningBookingWizard_diningReservationHold on DiningReservationHold {\n  id\n  date\n  expiresAt\n  partySize\n  policy\n  time\n}\n\nfragment useInitializeDiningBookingWizard_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Member {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "764562754488878a3bded47150b6ebbd";

export default node;
